module.exports={
    products: {
    	commodityManage:'Product Management',
    	search:'Search',
    	import:'Import',
        download:'Download',
    	add:'Add',
		delete:'Delete',
		submiting: 'Submitting...',
    	table1:{	//商品管理表格
            barcode:'Barcode',
    		index:'Number',
            name:'Product Name',
    		brand:'Brand',
    		specification:'Specification',
            price:'Price',
    		status:'Status',
            statusUnbound:'未绑定',
            statusBind:'已绑定',
            statusUnbound1:'Unbound',
            statusBind1:'Bound',
    		operation:'Operation',
    		delete:'Delete'
    	},
    	commodityDetails:'Product Information',
    	form1:{		//商品详情表单
    		proNo:'Product Number:',
    		name:'Product name:',
    		proAbbr:'Product name Abbreviation:',
    		price:'Price:',
    		brand:'Brand:',
    		specification:'Specification:',
    		rating:'Grade:',
    		piece:'Unit:',
    		origin:'Place of Origin:',
            supplierName:'Supplier:',
    		barcode:'Barcode:',
    		qrcode:'QR code:',
    		save:'Save',
            hint:'Please select a product!',
            success:'The product is successfully modified, the update ESL command is sent successfully, please refresh the page to get the latest data!',
            fail:'Modification of the product failed!',
            fail0:'The product was successfully modified and the update ESL failed!',
            fail1:'The modification of the product failed, the ESL is not bound to the gateway!',
            fail2:'The modification of the product failed, and the corresponding ESL was not imported!',
            fail3:'Failed to modify the product, there is an empty template in the bound ESL!',
            fail4:'The product was successfully modified, the update ESL failed, and the product has no binding ESL!',
            fail5:'If the product is modified successfully, the update ESL fails, and the template bound to the ESL does not exist!',
            noPermission:'Modification of the product failed,no permission!',
            label:'ESL ',
            length:'Within {num} characters',
            barcodeLen:'13 digits in length',
            unfold:'unfold',
            fold:'fold'

    	},
    	preview:'Preview',
    	bindTag:'Bound Label',
    	table2:{     //绑定标签表格
    		mac:'MAC Address',
    		demoName:'Template',
    		status:'Status',
            statusSucceeded:'Update succeeded',
            // statusSucceeded1:'Update succeeded',
            statusFailed:'Update failed',
            // statusFailed1:'Update failed',
    		operation:'Operation',
    		delete:'Delete',
    		push:'Re-push',
    		update:'Modify',
    	},
    	dialogAdd:{   //商品管理-新增弹框
    		dialogTitle:'Add',
    		proNo:'Product Number',
    		name:'Product Name',
    		proAbbr:'Product name Abbreviation',
    		price:'Price',
    		brand:'Brand',
    		specification:'Specification',
    		rating:'Grade',
    		piece:'Unit',
    		origin:'Place of Origin',
    		barcode:'Barcode',
    		qrcode:'QR code',
            supplierName:'Supplier',
    		cancel:'Cancel',
    		sure:'OK',
            addProSuccess:'Add product success!',
            addProFail:'Adding a product failed!',
            noPermission:'Adding a product failed,no permission!',
            alreadyExists:'Product has been added!'

        },
        dialogExport:{
            more:"More",
            allExport:"Export all",
            partExport:"Export",
            dialogTitle:"Export",
            dialogMsgAll:"Are you sure to export all products?",
            dialogMsgPart:"Are you sure to export the selected products?",
            hint:"Please select the product to export first！",
            errorMsg:"Product export failed!"
        },
        dialogRgb:{
            rgbSet:"RGB light setting",
            timeRgb:"RGB light on time:",
            colorRgb:"RGB light on Color:",
            setIlluminate:"brightness setting:",
            selectTime:"Please select the time",
            openRgb:"Light up",
            shutRgb:"Light out",
            Red:"red",
            Gre:"green",
            Blu:"blue",
            hint:"Please check the goods to be operated!",
            noBind:"No gateway is bound"   ,
            noLable:"There is no such label",
            getawayoffLine:"The Gateway is offline",
            checkTime:"Too long lighting time will accelerate battery loss",
            label:'ESL ',
            successOpenAll:'All lighting command sent successfully',
            errorOpenAll:'Failed to send all label lighting commands',
            successOpenPart:'Partial lighting command sent successfully',
            successShutAll:"All turn-off-the-light command sent successfully",    
            successShutPart:"Partial light-off command sent successfully",  
            errorShutAll:"Failed to send light off command for all tags",
            failList:"Failure list",
            successHit:'RGB light set successfully',
            warHit:"RGB light setting failed",
            cardNoLable:"The product is not bound, please bind the label first"
        },
    	dialogDelAll:{ //商品管理-删除选中全部弹框
    		dialogTitle:'Delete',
    		dialogMsg:'Are you sure you want to delete the selected product?',
            hint:'Please select the product you want to delete first!',
            deleteSuccess:'Batch delete products successfully!',
            deleteFail:'Failed to delete products in bulk!',
            noPermission:'Failed to delete products in bulk,no permission!',
    	},
    	dialogDel1:{ //商品管理-删除弹框
    		dialogTitle:'Delete',
    		dialogMsg:'Are you sure you want to delete the product with ID {id}?',
            success:'Deleting products successfully!',
            fail:'Deleting products failed!',
            noPermission:'Deleting products failed,no permission!'
    	},
    	dialogSave:{ //商品详情-保存弹框
    		dialogTitle:'Save',
    		dialogMsg:'Are you sure you want to save?',
    	},
    	dialogDel2:{ //绑定标签-删除弹框
    		dialogTitle:'Delete',
    		dialogMsg:'Are you sure you want to delete {mac}?',
    	},
    	dialogPush:{ //绑定标签-重推弹框
    		dialogTitle:'Re-push',   //数据库数据，判断权限，不可改动
    		dialogMsg:'Are you sure to re-push {mac}?',
            updateSuccess:'更新成功',
            updateFail:'更新失败',  //数据库数据，判断权限，不可改动
            hint:'The ESL has not been pushed for the first time. Please operate the push function!',
            successMsg1:'The current ESL device has been updated successfully, no need to re-push!',
            pushSuccess:'Re-push successful!',
            pushFail:'Re-push failed!',
            updateSuccess2:'The device has been updated successfully, please refresh the page to get the latest data!',
            noTemplate:'Template does not exist',
            noGateway:'The bound gateway is not the gateway of this store',
            noBind:'The ESL unbound gateway'

    	},
    	dialogUpdate:{ //绑定标签-修改弹框
    		dialogTitle:'Modify',
    		mac:'MAC address',
    		demoName:'Template',
            chooseTemplate:'Please select a template',
    		cancel:'Cancel',
    		sure:'OK',
            getTemplateFail:'Failed to get all templates for this size! Please re-operate',
            success:'Modify the template of the ESL binding successfully!',
            fail:'Modifying the template for ESL binding failed!',
            bindGateway:'Please bind the device to the gateway first!',
            tip:'The current ESL is not bound to the gateway. Please bind the gateway before operating this function.',
            noTemplate:'Template does not exist',
            noGateway:'The bound gateway is not the gateway of this store',
            problemTemplate:'The template bound to this ESL is incorrect. Please re-bind the correct template.',
            noTemplates:'There is no corresponding matching template. Please add a template of the corresponding type.'
    	},
        queryLabel:{ //绑定标签-查询标签
            fail:'Querying the label bound to the product failed!',
            msg:'The product is not bound to the ESL'
        },
        queryProduct:{ //查询商品
            fail:'Failed to query products!'
        },
        getPrefix:{ //获取标签前缀
            fail:'Failed to get the label prefix'
        },
        unbind:{
            success:'Unbind the product and ESL successfully!',
            fail:'Unbind the product and ESL failed!'
        },
        labelLight:{   //标签灯
            green1:'/static/images/label_green_1.png',
            green2:'/static/images/label_green_2.png',
            blue1:'/static/images/label_blue_1.png',
            blue2:'/static/images/label_blue_2.png',
            red1:'/static/images/label_red_1.png',
            red2:'/static/images/label_red_2.png'
        },
        labelLightMsg:{   //标签灯提示信息
            green:'Bright green light',
            red:'Bright red light',
            blue:'Bright blue light',
            success:'ESL {mac}:The {color} light command was sent successfully.',
            fail:'ESL {mac}:The {color} light command was sent failed.',
            unbind:'ESL {mac}:Current ESL is not bound to the gateway',
            noLabel:'ESL {mac}:Current ESL does not exist',
            chooseLabel:'Please select the ESL to be lit',
            color:[{
                key:'1',
                value:'blue'
            },{
                key:'2',
                value:'green'
            },{
                key:'3',
                value:'red'
            }]
        },
        cancel:'Cancel',
        sure:'OK',
        hint:'Prompt',
        checkout:{
            // formatAndDecimals:'请输入正确格式,最多有两位小数',
            formatAndDecimals1:'Please enter the correct format',
            formatAndDecimals2:'Up to two decimals',
            id:'Please enter a ID',
            length:'Please enter 13 digits',
            productAdd:'Product added',
            fail:'Failed to get, please re-enter',
            proNo:'Please enter a letter or number'
        },
        upload:{
            format:'Upload files can only be Excel spreadsheets',
            success:'Imported products successfully, successful {success}!',
            fail:'Importing the product failed!',
            incorrectFormat:'The file format is incorrect!',
            parseFail:'File parsing failed!',
            noPermission:'Failed to import the product,no permission!'
        },
        permission:{  //数据库数据，判断权限，不可改动
            addPro:'新增商品',
            delPro:'删除商品',
            updatePro:'修改商品'
        },
        timeSet:[{lab:'1 minute',val:'60'},{lab:'30 minute',val:'1800'},{lab:'1 hour',val:'3600'},{lab:'2 hour',val:'7200'},{lab:'4 hour',val:'14400'},{lab:'8 hour',val:'28800'},{lab:'12 hour',val:'43200'}],
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/products.js